import service from '@/store/services/settings/ports-service';

const state = {
    list: {},
    port: {},
    department: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, port) => {
        state.port = port;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(port => {
                commit('SET_RESOURCE', port);
            });
    },


    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(port => {
                commit('SET_RESOURCE', port);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((port) => {
                commit('SET_RESOURCE', port);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((port) => {
                commit('SET_RESOURCE', port);
            });
    },
    departments ({ commit, dispatch }, port) {
        return service.departments(port)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    port: state => state.port,
    department: state => state.department,
    dropdown: (state) => {
        return state.list.map(port => ({
            id: port.id,
            name: port.name,
            short_name: port.short_name,
            code: port.code,
            station_id: port.station_id
        }));
    }
};

const ports = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default ports;
